import { Component, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { helper } from 'src/environments/helper';
import { CererePriorityEditPayload, CererePriorityAddPayload } from '../../cerere-priority/cerere-priority.interface';
import { CererePriorityService } from '../../cerere-priority/cerere-priority.service';
import { EditCererePriorityComponent } from '../../cerere-priority/edit-cerere-priority/edit-cerere-priority.component';
import { BorderouDatatableService } from '../borderou-datatable.service';

@Component({
  selector: 'app-edit-borderou-datatable',
  templateUrl: './edit-borderou-datatable.component.html',
  styleUrls: ['./edit-borderou-datatable.component.scss']
})
export class EditBorderouDatatableComponent {
	// general error
	errorTitle: string = helper.dialogConfig.headers.errorAtentie;
	errorIcon: string = helper.dialogConfig.icons.error;
	errorType: string = helper.dialogConfig.icons.error;
	helper = helper;

	token!: string;
	isLoading = false;
	form: FormGroup = new FormGroup({
		name: new FormControl(this.data.name, [Validators.required]),
		observatii: new FormControl(this.data.observatii, []),
		slug: new FormControl(this.data.slug, [Validators.required]),
	});

  constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		private dialogRef: MatDialogRef<EditBorderouDatatableComponent>,
		private borderouService: BorderouDatatableService,
		private notificationService: NotificationService,
		private authService: AuthService
	) {
		this.processToken();
	}

	closeDialog() {
		this.dialogRef?.close({
			success: false,
		});
	}

	processToken() {
		const tokenObj = this.authService.returnTokenUser();
		tokenObj.then((token) => {
			this.token = token;
			this.borderouService.setToken(token);
		});
	}

	submitForm() {
		this.isLoading = true;

		const { name, observatii, slug } = this.form
			.value
		const updateBorderou = {
			id: this.data.id,
			name,
			observatii,
			slug,
		};

		this.borderouService
			.update(updateBorderou)
			.pipe(finalize(() => (this.isLoading = false)))
			.subscribe({
				next: () => {
					this.dialogRef.close({ success: true });
				},
				error: (err) => {
					let msg;
					try {
						// try to catch the message from server
						msg = err.error.errors.message[0];
					} catch (error) {
						// controll output message
						msg = helper.dialogConfig.generalMessages.error;
					}
					this.notificationService.warningSwal(
						helper.dialogConfig.headers.errorAtentie,
						msg,
						this.errorIcon
					);
				},
			});
	}

	onHttpError(res: any) {
		if (res.errors && res.errors.message && res.errors.message.length > 0) {
			res.errors.message.forEach((msg: string) => {
				this.notificationService.warningSwal(
					this.errorTitle,
					msg,
					this.errorIcon
				);
			});
		} else {
			let msg;
			try {
				// try to catch the message from server
				msg = res.error.errors.message[0];
			} catch (error) {
				// controll output message
				msg = helper.dialogConfig.generalMessages.error;
			}
			this.notificationService.warningSwal(
				this.errorTitle,
				msg,
				this.errorIcon
			);
		}
	}
}
